import { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomePageComponent } from './pages/home/home-page.component';
import { ReportingPageComponent } from './pages/reporting/reporting-page.component';
import { ReportingDailyPageComponent } from './pages/reporting/daily/reporting-daily-page.component';
import { BudgetPageComponent } from './pages/budget/budget-page.component';
import { AdminUsersPageComponent } from './pages/admin/users/admin-users-page.component';
import { AdminCurrencyPageComponent } from './pages/admin/currency/admin-currency-page.component';
import { AdminMonthsPageComponent } from './pages/admin/months/admin-months-page.component';
import { AccessDeniedPageComponent } from './pages/access-denied/access-denied-page.component';
import { adminGuard } from './guards/admin.guard';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadComponent: () =>
      import('@azure/msal-angular').then((m) => m.MsalRedirectComponent),
  },
  { path: 'access-denied', component: AccessDeniedPageComponent },
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'home', component: HomePageComponent, canActivate: [MsalGuard] },
  {
    path: 'reporting',
    component: ReportingPageComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'reporting/daily',
    component: ReportingDailyPageComponent,
    canActivate: [MsalGuard],
  },
  { path: 'budget', component: BudgetPageComponent, canActivate: [MsalGuard] },
  {
    path: 'admin/users',
    component: AdminUsersPageComponent,
    canActivate: [MsalGuard, adminGuard],
  },
  {
    path: 'admin/currency',
    component: AdminCurrencyPageComponent,
    canActivate: [MsalGuard, adminGuard],
  },
  {
    path: 'admin/months',
    component: AdminMonthsPageComponent,
    canActivate: [MsalGuard, adminGuard],
  },
  { path: '**', redirectTo: 'home' },
];
